import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dhhp-card-content',
  template: `<mat-card-content>
  <ng-content></ng-content>
</mat-card-content>`
})
export class DhhpCardContentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
